"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PARTNERSHIPS_LEAD_MAX_ANNUAL_AMOUNT = exports.PartnershipsLeadSources = exports.PartnershipsLeadSource = exports.MerchantApplicationStatus = exports.stripSensitiveBankingFields = exports.MerchantApplicationAccountType = exports.MerchantApplicationDocumentType = void 0;
var MerchantApplicationDocumentType;
(function (MerchantApplicationDocumentType) {
    MerchantApplicationDocumentType["taxReturnOrFinancialStatement"] = "taxReturnOrFinancialStatement";
    MerchantApplicationDocumentType["businessLicense"] = "businessLicense";
    MerchantApplicationDocumentType["bankVerification"] = "bankVerification";
    MerchantApplicationDocumentType["insurance"] = "insurance";
    MerchantApplicationDocumentType["recentSampleContract"] = "recentSampleContract";
    MerchantApplicationDocumentType["clientRescissionNotice"] = "clientRescissionNotice";
})(MerchantApplicationDocumentType || (exports.MerchantApplicationDocumentType = MerchantApplicationDocumentType = {}));
var MerchantApplicationAccountType;
(function (MerchantApplicationAccountType) {
    MerchantApplicationAccountType["business"] = "business";
    MerchantApplicationAccountType["personal"] = "personal";
})(MerchantApplicationAccountType || (exports.MerchantApplicationAccountType = MerchantApplicationAccountType = {}));
const stripSensitiveBankingFields = (application) => {
    const { bankTaxId, bankSocialSecurityNumber, routingNumber, accountNumber, ...persistedApplication } = application;
    return persistedApplication;
};
exports.stripSensitiveBankingFields = stripSensitiveBankingFields;
var MerchantApplicationStatus;
(function (MerchantApplicationStatus) {
    MerchantApplicationStatus["inProgress"] = "inProgress";
    MerchantApplicationStatus["awaitingGoogleDriveUpload"] = "awaitingGoogleDriveUpload";
    MerchantApplicationStatus["submitted"] = "submitted";
})(MerchantApplicationStatus || (exports.MerchantApplicationStatus = MerchantApplicationStatus = {}));
var PartnershipsLeadSource;
(function (PartnershipsLeadSource) {
    PartnershipsLeadSource["homeImprovement"] = "home_improvement";
    PartnershipsLeadSource["coBrand"] = "co_brand";
})(PartnershipsLeadSource || (exports.PartnershipsLeadSource = PartnershipsLeadSource = {}));
exports.PartnershipsLeadSources = [PartnershipsLeadSource.homeImprovement, PartnershipsLeadSource.coBrand];
exports.PARTNERSHIPS_LEAD_MAX_ANNUAL_AMOUNT = 1_000_000_000;
